export default [
  { value: 'account_support', name: 'Membership / Account Support' },
  { value: 'institutional_membership', name: 'Institutional Membership' },
  { value: 'faculty_success_program', name: 'Faculty Success Program' },
  { value: 'technical_issue', name: 'Technical Issue' },
  { value: 'campus_workshop', name: 'Campus Workshop' },
  { value: 'general_inquiry', name: 'Other / General Inquiry' },
  { value: 'writenow_access', name: 'WriteNow Access' }
]
